import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowRightFill } from '@lyearn/icons';
import { BaseButton } from '@lyearn/ui';
import { svgSizeStyles } from '@/utils/styles';

import { useBaseCard } from '../Provider';
import { BaseCardComposition } from '../types';

const CLASSES = {
  root: 'p-0 hover:bg-transparent label-02 text-link-internal hover:text-text-primary group-hover:text-text-primary focus-visible:text-text-primary',
  label: 'inline-flex',
  iconSizeMedium: svgSizeStyles(2),
};

const PrimaryAction: BaseCardComposition['PrimaryAction'] = (props) => {
  const { t } = useTranslation();
  const { progress } = useBaseCard();
  let label = t('ContentCards.StartLearning');
  if (progress === 100) {
    label = t('ContentCards.RevisitLearning');
  } else if (progress! > 0) {
    label = t('ContentCards.ContinueLearning');
  }

  return (
    <BaseButton
      classes={CLASSES}
      endIcon={<ArrowRightFill className="rtl:rotate-180" />}
      {...props}>
      {props.children ?? label}
    </BaseButton>
  );
};

export default PrimaryAction;
